<h1 *ngIf="forTosDetails" [style.color]="color">{{ title }}</h1>
<div id="html-content" class="description">
  <ng-container *ngFor="let elem of domElements">
    <div
      [innerHTML]="elem.el"
      *ngIf="elem.type === 'html' && !forTosDetails"
      style="
        color: var(--ion-text-color-dark-black);
        text-align: justify;
        text-justify: inter-word;
        align-items: center;
      "
    >
      {{ elem.el }}
    </div>
    <div
      [innerHTML]="elem.el"
      *ngIf="elem.type === 'html' && forTosDetails"
      style="color: var(--ion-text-color-dark-black)"
      bpAddRtlClass
    >
      {{ elem.el }}
    </div>

    <div
      class="container"
      *ngIf="elem.type === 'button' && !forTosDetails"
      style="align-items: center"
    >
      <ion-button
        style="
          color: var(--ion-color-light);
          height: auto;
          text-transform: none;
          max-width: 80%;
          white-space: normal;
          --padding-top: 4px;
          --padding-bottom: 4px;
          --border-color: white;
        "
        size="default"
        shape="round"
        fill="outline"
        (click)="htmlItemClick(elem.el)"
      >
        {{ elem.el }}
      </ion-button>
    </div>
    <a
      *ngIf="elem.type === 'button' && forTosDetails"
      bpAddRtlClass
      (click)="htmlItemClick(elem.el)"
    >
      {{ elem.el }}
    </a>
  </ng-container>
</div>
